import type { ChangeEvent, ReactNode } from 'react';
import { memo } from 'react';
import usePagination from '@mui/material/usePagination';

import { Button } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import clsx from 'clsx';
import { useStyles } from './style';

interface Props {
  totalPages: number;
  currentPage: number;
  onChange: (e: ChangeEvent<unknown>, page: number) => void;
  disabled?: boolean;
}

const TablePagination: React.FC<Props> = ({
  totalPages,
  currentPage,
  onChange,
  disabled = false,
}) => {
  const classes = useStyles();
  const { items } = usePagination({
    count: totalPages,
    page: currentPage,
    onChange,
  });

  return (
    <ul className={classes.ul}>
      {items.map(({ page, type, selected, ...item }, index) => {
        let children: ReactNode = null;

        if (type === 'start-ellipsis' || type === 'end-ellipsis') {
          children = '…';
        } else if (type === 'page') {
          children = (
            <Button
              {...item}
              disabled={disabled || item.disabled}
              classes={{
                root: clsx(classes.btnPage, {
                  [classes.selectedBtn]: selected,
                }),
              }}
              type="button"
            >
              {page}
            </Button>
          );
        } else {
          children = (
            <Button
              {...item}
              classes={{
                root: classes.btnPage,
              }}
              type="button"
              disabled={disabled || item.disabled}
            >
              {type === 'previous' ? (
                <ChevronLeftIcon className={classes.icon} />
              ) : type === 'next' ? (
                <ChevronRightIcon className={classes.icon} />
              ) : null}
            </Button>
          );
        }

        return <li key={index}>{children}</li>;
      })}
    </ul>
  );
};

export default memo(TablePagination);
